import React from "react"
import { getTranslationString } from "Utils/getTranslation"
import { getFieldFromUUID } from "Utils/dataCatalogueUtils.js"

const listOfSimpleOperationId = ["mean", "max", "min", "sum", "sub", "prod", "std", "count"]

const isSimpleOperation = operationId => {
  //At the moment every operation is 'simple'
  // return operationId !== undefined && listOfSimpleOperationId.includes(operationId)
  return true
}

export const getDetailledOperation = (operationId, languageId = 0) => {
  var operationTrad = getTranslationString(operationId, languageId)
  return {
    id: operationId,
    name: operationTrad ? operationTrad : operationId,
    type: isSimpleOperation(operationId) ? "simple" : "complex",
  }
}

export const getDetailledOperationList = (operationIdList, languageId = 0) => {
  return operationIdList.map(id => getDetailledOperation(id, languageId))
}

export const getFieldFromUUIDForPrepa = (fieldsData, fieldUUID, languageId = 0, requestLoad) => {
  let fieldToReturn

  if (requestLoad && requestLoad.length > 0) {
    if (requestLoad[0]?.fieldUUID?.includes("%")) {
      // Ancien widget
      const correspondance = requestLoad?.find(it => it?.outputUUID === fieldUUID)
      const fieldName = correspondance?.fieldUUID?.split("%")?.[2]
      fieldToReturn = fieldName
    } else {
      // Nouveau widget
      fieldToReturn = getFieldFromUUID(fieldsData, fieldUUID)
    }
  } else {
    fieldToReturn = getFieldFromUUID(fieldsData, fieldUUID)
  }

  if (fieldToReturn !== undefined) {
    return fieldToReturn
  } else {
    var notFoundTranslation = getTranslationString("FIELD_NOT_FOUND", languageId)
    var labelToUse = notFoundTranslation ? notFoundTranslation : "undefined Label"
    return {
      tags: {
        label: labelToUse,
        isUndefined: true,
        color: "#606060",
      },
    }
  }
}

export const getFieldsFromUUIDs = (fieldsData, listOfFieldsUUID, languageId, requestLoad) => {
  return listOfFieldsUUID.map(fieldUUID =>
    getFieldFromUUIDForPrepa(fieldsData, fieldUUID, languageId, requestLoad)
  )
}
